import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { ApiError } from "@/api/client";
import { useAdminMe } from "@/hooks/useAdminAuth";

function authStatus(error: unknown): number | undefined {
  if (error instanceof ApiError) return error.status;
  return (error as { status?: number })?.status;
}

export default function RequireAdminAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const admin = useAdminMe();

  if (admin.isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-[#003f28]/70"
        role="status"
      >
        Comprobando sesión admin…
      </div>
    );
  }

  if (admin.isError && authStatus(admin.error) === 401) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
